import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useConsent } from "@/context/ConsentContext";

export default function Footer() {
  const { t } = useI18n();
  const { openManager } = useConsent();
  return (
    <footer className="bg-charcoal text-white/80 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-16 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src="/velyrea-logo.png" alt="Velyrea" className="h-16 w-16 object-contain" />
            <span className="font-serif text-2xl font-bold text-white">Velyrea</span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">Discover Your Perfect Beauty & Style. Il tuo consulente digitale di bellezza e stile.</p>
          <div className="flex gap-3 mt-5">
            <Instagram size={20} className="hover:text-rose-400 cursor-pointer transition-colors" />
            <Facebook size={20} className="hover:text-rose-400 cursor-pointer transition-colors" />
            <Youtube size={20} className="hover:text-rose-400 cursor-pointer transition-colors" />
          </div>
        </div>
        <div>
          <h4 className="font-serif text-lg text-white mb-4">{t("nav.armocromia")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/armocromia" className="hover:text-rose-400">Stagioni</Link></li>
            <li><Link to="/quiz" className="hover:text-rose-400">{t("nav.quiz")}</Link></li>
            <li><Link to="/hair" className="hover:text-rose-400">{t("nav.hair")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-white mb-4">Cataloghi</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalog/makeup" className="hover:text-rose-400">{t("nav.makeup")}</Link></li>
            <li><Link to="/catalog/skincare" className="hover:text-rose-400">{t("nav.skincare")}</Link></li>
            <li><Link to="/catalog/fashion" className="hover:text-rose-400">{t("nav.fashion")}</Link></li>
            <li><Link to="/outfits" className="hover:text-rose-400">{t("nav.outfits")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-white mb-4">Guide SEO</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/guide" className="hover:text-olive-light">Tutte le guide</Link></li>
            <li><Link to="/guide/migliori-rossetto-per-sottotono-caldo" className="hover:text-olive-light">Rossetti sottotono caldo</Link></li>
            <li><Link to="/guide/migliori-siero-per-pelle-matura" className="hover:text-olive-light">Sieri pelle matura</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-white mb-4">Informative</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/cookie-policy" className="hover:text-olive-light" data-testid="footer-cookie">Cookie Policy</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-olive-light" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/termini-condizioni" className="hover:text-olive-light" data-testid="footer-terms">Termini e Condizioni</Link></li>
            <li><Link to="/disclaimer" className="hover:text-olive-light" data-testid="footer-disclaimer">Disclaimer</Link></li>
            <li><button onClick={openManager} className="hover:text-olive-light" data-testid="footer-manage-cookies">Gestisci cookie</button></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 px-6 md:px-8 max-w-7xl mx-auto">
        <p className="text-[11px] leading-relaxed text-white/40">
          Disclaimer: Velyrea fornisce suggerimenti generati automaticamente sulla base di principi di armocromia, algoritmi di
          matching e informazioni inserite dall'utente. I consigli hanno finalità puramente informative e orientative, non
          costituiscono consulenza professionale (medica, dermatologica o di altra natura) e non devono essere considerati
          come garanzia di risultato. Velyrea non è responsabile di eventuali scelte d'acquisto o esiti derivanti dall'utilizzo
          del servizio. I prezzi e la disponibilità dei prodotti possono variare sui siti dei rivenditori. Alcuni link sono di
          affiliazione.
        </p>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Velyrea.com — Discover Your Perfect Beauty & Style
      </div>
    </footer>
  );
}
